"use client";

export function replaceLocationHash(hash: string = ""): void {
  if (typeof window === "undefined") {
    return;
  }

  const normalizedHash = hash
    ? hash.startsWith("#")
      ? hash
      : `#${hash}`
    : "";
  const nextUrl = `${window.location.pathname}${window.location.search}${normalizedHash}`;
  const currentUrl =
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (currentUrl === nextUrl) {
    return;
  }

  window.history.replaceState(window.history.state, "", nextUrl);
  window.dispatchEvent(new Event("hashchange"));
}
